<template>
  <div>
    <div class="viewZone">
      <div class="introBox">
        <img
          v-for="(poster, index) in posterList"
          :key="index"
          :src="poster.src + '?imageView2/0/format/webp'"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    displayImg: Function,
    isShowImg: Boolean,
    posterList: Array,
  },
};
</script>

<style scoped>
.introBox {
  width: 100%;
  height: fit-content;
  margin: auto;
  display: flex;
  overflow-x: scroll;
}
.slogan {
  width: 92.5%;
  height: 2.5rem;
  background: #f3edfe;
  border-radius: 0.5rem;
  margin: auto;
  margin-top: 0.6rem;
  margin-bottom: 1.3rem;
  color: #848189;
  font-size: 1.2rem;
  text-align: center;
}
.descrBox {
  width: 100%;
  height: auto;
  min-height: 12rem;
}
.descrBox p {
  width: 90%;
  margin: auto;
  text-align: right;
  direction: rtl;
}
.descrBox .descrTitle {
  color: #292929;
  font-size: 1.3rem;
  font-weight: bold;
  margin-top: 1.6rem;
  line-height: 1.8;
}
.descrBox .descr {
  color: #575656;
  font-size: 1.2rem;
  line-height: 1.8;
}
.introBox img {
  width: 9.4rem;
  height: 16.8rem;
  margin-right: 0.7rem;
  border-radius: 0.7rem;
}
.tag {
  color: #9b65ff;
  padding: 0.6rem 1.2rem 0.1rem 1.2rem;
  background: #ede4fe;
  border-radius: 1.3rem 1.3rem 0 1.3rem;
  margin-left: 0.7rem;
  font-size: 1.1rem;
}
</style>
